import * as types from '../constants'
import { clear } from "redux-localstorage-simple"

const defaultTokenState = {
  accessToken: '',
  loginSuccess: false,
  loginFailure: false,
  pending: false,
  signedIn: false,
  isAdmin: false,
  user: {}
}

export default (state = defaultTokenState, action) => {

  var newState = {...state}

  switch (action.type){
    case types.FETCH_APP_TOKEN_SUCCESS:
      newState.accessToken = action.body.access_token;
      newState.loginSuccess = true;
      newState.pending = false;
      newState.signedIn = true;
      return newState;
    case types.FETCH_APP_TOKEN_REQUEST:
      newState.pending = true;
      return newState;
    case types.LOG_AS_ADMIN:
      newState.isAdmin = action.body;
      return newState;
    case types.CLEAR_APP_TOKEN:
      newState = defaultTokenState;
      clear(); //Clears the Redux LocalStorage
      return newState;
    case types.FETCH_APP_TOKEN_FAILURE:
      newState.loginFailure = true;
      newState.pending = false;
      return newState;
    case types.LOGIN_REQUEST:
      newState.pending = true;
      return newState;
    case types.LOGIN_SUCCESS:
      newState.user = action.body;
      newState.pending = false;
      return newState;
    case types.LOGIN_FAILURE:
      newState.pending = false;
      return newState;
    case 'REFRESH_USER':
      newState.user = action.body;
      return newState;
    default:  return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/app_token.js